import React, { useEffect } from 'react';
import { Package, Smartphone, ShoppingBag, Target, Sparkles } from 'lucide-react';
import '../styles/Home.css';

const featureIcons = {
  0: Package,
  1: Smartphone,
  2: ShoppingBag,
  3: Target,
  4: Sparkles
};

const About = () => {
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          if (isMobile) {
            entry.target.classList.add('revealed');
          }
        }
      });
    }, { threshold: 0.1 });

    const elements = document.querySelectorAll('.about-content, .about-visual, .mobile-scroll-reveal');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about section-padding">
      <div className="container">
        <div className="about-grid">
          <div className="about-content mobile-scroll-reveal">
            <h2 className="heading-1">Premium E-Commerce Experience</h2>
            <div className="about-text">
              <p className="body-large">
                Nowoczesna platforma e-commerce zaprojektowana dla marek premium i luksusowych. 
                Połączenie kinematograficznej estetyki, płynnych interakcji i UX ukierunkowanego na konwersję.
              </p>
              <p className="body-regular">
                Każdy element został starannie zaprojektowany, aby tworzyć immersyjne doświadczenie zakupowe 
                godne najlepszych światowych marek fashion i lifestyle.
              </p>
              <p className="body-regular">
                Zaawansowane efekty 3D, glassmorphism i subtelne animacje tworzą atmosferę luksusu 
                zachowując jednocześnie płynną wydajność na wszystkich urządzeniach.
              </p>
            </div>
          </div>
          <div className="about-visual mobile-scroll-reveal mobile-float">
            <div className="visual-card">
              <div className="visual-stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Premium Quality</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Features = ({ features }) => {
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animate-in');
            if (isMobile) {
              entry.target.classList.add('revealed');
            }
          }, index * 100);
        }
      });
    }, { threshold: 0.1 });

    const cards = document.querySelectorAll('.feature-card');
    cards.forEach(card => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="features" className="features section-padding-small">
      <div className="container">
        <div className="section-header mobile-float">
          <h2 className="heading-1">Zaawansowane Funkcje</h2>
          <p className="body-regular">Wszystko czego potrzebujesz dla sukcesu w sprzedaży online</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => {
            const Icon = featureIcons[index];
            return (
              <div key={index} className="feature-card mobile-scroll-reveal">
                <div className="feature-icon">
                  <Icon size={24} />
                </div>
                <h3 className="heading-3">{feature.title}</h3>
                <p className="body-small">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { About, Features };
